import { Pagination, Typography } from "@mui/material";
import { AiFillPlusCircle } from "react-icons/ai";

import PageCountSelect from "../PageCountSelect";
import CustomButton from "../CustomButton";
import CustomSearchInput from "..//CustomInput/CustomSearchInput";

import "./style.css";
import CustomSort from "../CustomSort";
import { useState } from "react";

function CustomTable({
    title = "",
    description = "",
    table = {},
    list = [],
    pagination,
    actions,
    sort,
}) {

    const [activeSort, setActiveSort] = useState(null);

    return (
        <div id="custom-table">
            <div id="custom-table-wrapper">
                <div id="ctw-header">
                    <div id="ctw-title">
                        <h4>{title}</h4>
                        <p>{description}</p>
                    </div>
                    <div id="ctw-actions">
                        <CustomSearchInput
                            handleChange={(e) => {
                                actions.search.onChange(e);
                                actions.search.onClick();
                            }} onclick={() => {
                                actions.search.onClick();
                            }}
                        />
                        <div>
                            {actions.add && <CustomButton onClick={actions.add}><AiFillPlusCircle />ADD</CustomButton>}
                        </div>
                        <div>
                            {actions.qr && <CustomButton onClick={actions.qr}>SHOW QR</CustomButton>}
                        </div>
                    </div>
                </div>
                <div id="ctw-table">
                    <table>
                        <thead>
                            <tr>
                                {
                                    table.headers.map(({ title, value }, i) => {
                                        return (
                                            <th>
                                                <div>
                                                    <h5>
                                                        {title}
                                                    </h5>
                                                    {
                                                        value && <CustomSort active={(activeSort && activeSort.key == value) ? activeSort.order : null} Sort={(sortType) => {
                                                            setActiveSort({
                                                                key: value,
                                                                order: sortType
                                                            });
                                                            sort(value, sortType);
                                                        }} />
                                                    }
                                                </div>
                                            </th>
                                        )
                                    })
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {
                                list && list.map(
                                    (item, i) => {
                                        return (
                                            table.body(
                                                item,
                                                ((pagination.page - 1) * pagination.perPage) + (i + 1),
                                            )
                                        )
                                    })
                            }
                        </tbody>
                    </table>
                </div>
                <div id="ctw-footer-actions">
                    <div style={{ display: "flex", marginTop: "10px" }}>
                        <Typography style={{ marginRight: "10px" }}>Page: {pagination.page} of {Math.ceil(pagination.count / pagination.perPage)}</Typography>
                        <PageCountSelect onChange={(val) => {
                            pagination.setPerPage(val);
                        }} />
                    </div>
                    <Pagination count={Math.ceil(pagination.count / pagination.perPage)} page={pagination.page} variant="outlined" shape="rounded" onChange={pagination.paginate} />
                </div>
            </div>
        </div>
    );
}

export default CustomTable;